const PENDING_POST_READ_ARTICLE_REWARD_KEY = 'pendingPostReadArticleReward';

export const setPendingPostReadArticleReward = ({ articleId, packId }) => {
  localStorage.setItem(
    PENDING_POST_READ_ARTICLE_REWARD_KEY,
    JSON.stringify({
      articleId,
      packId,
    }),
  );
};

export const getPendingPostReadArticleReward = () => {
  const pendingReward = localStorage.getItem(PENDING_POST_READ_ARTICLE_REWARD_KEY);

  if (!pendingReward) {
    return null;
  }

  try {
    return JSON.parse(pendingReward);
  } catch (error) {
    localStorage.removeItem(PENDING_POST_READ_ARTICLE_REWARD_KEY);
    return null;
  }
};

export const clearPendingPostReadArticleReward = () => {
  localStorage.removeItem(PENDING_POST_READ_ARTICLE_REWARD_KEY);
};
